import { render, staticRenderFns } from "./OrthesesPlantaires.vue?vue&type=template&id=124657f7&"
import script from "./OrthesesPlantaires.vue?vue&type=script&lang=js&"
export * from "./OrthesesPlantaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports